export const DEFAULT_ADDITIONAL_OPTIONS = [
  { value: "TT4", label: "TT4" },
  { value: "SDMA", label: "SDMA" },
  { value: "Urine Analysis", label: "Urine Analysis" }
];
